import {
  REPRINT_CERTIFICATE_TYPE,
  REPRINT_CERTIFICATE_TYPE_CLEAR_DATA,
  REPRINT_CERTIFICATE_TYPE_ERROR,
  REPRINT_CERTIFICATE_TYPE_SUCCESS,
} from "./actionTypes";

const initialState = {
  loadingReprintType: false,
  responseReprintType: null,
  errorReprintType: null,
};

const Reprint = (state = initialState, action) => {
  switch (action.type) {
    case REPRINT_CERTIFICATE_TYPE:
      state = {
        ...state,
        loadingReprintType: true,
        responseReprintType: null,
        errorReprintType: null,
      };
      break;
    case REPRINT_CERTIFICATE_TYPE_SUCCESS:
      state = {
        ...state,
        loadingReprintType: false,
        responseReprintType: action.payload,
        errorReprintType: null,
      };
      break;
    case REPRINT_CERTIFICATE_TYPE_ERROR:
      state = {
        ...state,
        loadingReprintType: false,
        responseReprintType: null,
        errorReprintType: action.payload,
      };
      break;
    case REPRINT_CERTIFICATE_TYPE_CLEAR_DATA:
      state = {
        ...state,
        loadingReprintType: null,
        responseReprintType: false,
        errorReprintType: null,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default Reprint;
